import * as React from 'react';

import { CustomSVGProps } from 'styles/theme';

export const LinkedIn = (props: CustomSVGProps) => (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0.746094 1.71919C0.746094 0.77025 1.54053 0 2.51984 0H22.9723C23.952 0 24.7461 0.77025 24.7461 1.71919V22.2811C24.7461 23.2303 23.952 24 22.9723 24H2.51984C1.54063 24 0.746094 23.2304 0.746094 22.2814V1.71891V1.71919Z"
            fill="#0A66C2"
        />
        <path
            d="M8.03939 20.0857V9.28083H4.44802V20.0857H8.03977H8.03939ZM6.24445 7.80586C7.49658 7.80586 8.27611 6.97617 8.27611 5.9393C8.25267 4.8788 7.49658 4.07227 6.26827 4.07227C5.03911 4.07227 4.23633 4.8788 4.23633 5.9392C4.23633 6.97608 5.01558 7.80577 6.22092 7.80577H6.24417L6.24445 7.80586ZM10.0273 20.0857H13.6184V14.0524C13.6184 13.7299 13.6418 13.4066 13.7367 13.1762C13.9962 12.5308 14.5871 11.8626 15.5794 11.8626C16.8786 11.8626 17.3986 12.8534 17.3986 14.306V20.0857H20.9896V13.8905C20.9896 10.5719 19.2181 9.02752 16.8554 9.02752C14.9182 9.02752 14.0674 10.1102 13.5947 10.8477H13.6186V9.2812H10.0275C10.0743 10.2948 10.0272 20.0861 10.0272 20.0861L10.0273 20.0857Z"
            fill="white"
        />
    </svg>
);
